<template>
    <div class="comFooter1">
        <div class="comFooter_item_grid comFooter_top_grid">
            <div style="display: flex;align-items: center;">
                <div>{{ $t('关注我们') }}</div>
                <div style="margin-left: 0.5rem;">
                    <img src="@/assets/images/b1.png" alt="" style="width: 0.8rem;height: 0.8rem;">
                    <img src="@/assets/images/b2.png" alt="" style="width: 0.8rem;height: 0.8rem;margin-left: 0.5rem;">
                    <img src="@/assets/images/b3.png" alt="" style="width: 0.8rem;height: 0.8rem;margin-left: 0.5rem;">
                    <img src="@/assets/images/b4.png" alt="" style="width: 0.8rem;height: 0.8rem;margin-left: 0.5rem;">
                    <img src="@/assets/images/b5.png" alt="" style="width: 0.8rem;height: 0.8rem;margin-left: 0.5rem;">
                </div>
            </div>
        </div>
        <div class="comFooter_line"> </div>
        <div class="comFooter_item_grid comFooter_content_grid">
            <div class="comFooter_item">
                <div class="comFooter_item_grid_three">
                    <div>
                        <div v-for="child in Companylist" style="cursor: pointer;" :key="child.id"
                            @click="handleClick(child.path, child.type)" class="comFooter_item_title_child">
                            {{ child.title }}
                        </div>
                    </div>
                    <div>
                        <div v-for="child in lawlist" style="cursor: pointer;" :key="child.id"
                            @click="handleClick(child.path, child.type)" class="comFooter_item_title_child">
                            {{ child.title }}
                        </div>
                    </div>
                    <div>
                        <div class="comFooter_item_title">
                            {{ $t('联系我们') }}
                        </div>
                        <div class="comFooter_item_title_child">
                            {{ contactAddress }}
                        </div>
                        <div class="comFooter_item_title_child">
                            {{ locaLang === 'en' ? 'Phone' : '电话' }}：+1 2025508859
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toFooterConfigs } from "@/api/index";
export default {
    name: "Footer",

    data() {
        return {
            Companylist: [],
            lawlist: [],
        }
    },
    watch: {
        locaLang() {
            this.getFooterLinks();
        },
    },
    computed: {
        // 语言
        locaLang() {
            return this.$store.state.isLand || "zh";
        },
        contactAddress() {
            return this.locaLang === "en"
                ? "10490 Little Patuxent Parkway, Suite 600, Columbia, MD 21044, United States"
                : "美国马里兰州哥伦比亚市小帕图克森特公园路10490号，600室";
        },
    },
    mounted() {
        this.getFooterLinks();
    },
    methods: {
        handleClick(path, type) {
            if (path == this.$route.path) {
                return;
            }
            if (type == 'link') {
                window.open(path, '_blank');
            } else {
                this.$router.push({ path: path });
            }
        },
        getFooterLinks() {
            toFooterConfigs().then((res) => {
                if (res.code === 1) {
                    this.Companylist = res.data.type1.map(child => ({
                        id: child.id,
                        title: this.locaLang === 'en' ? child.name_en : child.name,
                        path: child.line,
                        type: 'link'
                    }));
                    this.lawlist = res.data.type2.map(child => ({
                        id: child.id,
                        title: this.locaLang === 'en' ? child.name_en : child.name,
                        path: child.line,
                        type: 'link'
                    }));
                }
            });
        }
    },
};
</script>

<style></style>
